import { render, staticRenderFns } from "./GooglePage.vue?vue&type=template&id=37167def&"
import script from "./GooglePage.vue?vue&type=script&lang=js&"
export * from "./GooglePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports